import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Input, Label } from 'reactstrap';
import { SettingsFormValues } from 'pages/SettingsV2/settingsTypes';
import { useSettings } from 'pages/SettingsV2/SettingsContext';
import SettingsV2SectionCard from 'pages/SettingsV2/SettingsV2SectionCard';

const ProductPriceSectionV2 = () => {
  const { t } = useTranslation();
  const { fieldErrors, clearFieldError, validateField } = useSettings();
  const { values, handleChange, handleBlur } =
    useFormikContext<SettingsFormValues>();

  return (
    <SettingsV2SectionCard
      sectionKey="productPrice"
      title={t('Product Price Settings')}
      icon="ri-price-tag-3-line"
    >
      {values.productPrice.groupPriceNames.map((name, idx) => (
        <div className="mb-3 row" key={idx}>
          <Label
            htmlFor={`price-group-${idx}`}
            className="col-sm-3 col-form-label"
          >
            {t('Group')} {idx + 1}
            {idx === 0 ? <span className="text-danger ms-1">*</span> : null}
          </Label>
          <Col sm={9}>
            <Input
              id={`price-group-${idx}`}
              type="text"
              name={`productPrice.groupPriceNames[${idx}]`}
              value={name}
              maxLength={50}
              onChange={(e) => {
                handleChange(e);
                clearFieldError(`productPrice.groupPriceNames[${idx}]`);
              }}
              onBlur={(e) => {
                handleBlur(e);
                validateField(`productPrice.groupPriceNames[${idx}]`);
              }}
              placeholder={`${t('Group')} ${idx + 1}`}
            />
            {idx === 0 && fieldErrors['productPrice.groupPriceNames[0]'] ? (
              <div className="text-danger mt-1 err-txt">
                {t(fieldErrors['productPrice.groupPriceNames[0]'] as string)}
              </div>
            ) : null}
          </Col>
        </div>
      ))}
    </SettingsV2SectionCard>
  );
};

export default ProductPriceSectionV2;
